import { Grid, Heading, useClipboard } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'ui-components';
import { GalleryViewIcon } from 'ui-components/dist/GalleryViewIcon';
import { ListViewIcon } from 'ui-components/dist/ListViewIcon';
import { useListAgencies } from '~/hooks/api/useListAgencies';
import { ViewCard } from '~/screens/MyAgency/components/ShareRosterModal';
import { selectTalentManager } from '~/selectors/talent-manager';
import { SITE_URL } from '~/utils';

export const LinkViews: React.FC = () => {
  const snackbar = useSnackbar();
  const router = useRouter();

  const agency = useListAgencies('');
  const manager = useSelector(selectTalentManager);

  const slug = useMemo(() => {
    if (router.pathname === '/my-roster') {
      return `manager/${manager.shareToken}`;
    }
    // typescript v5 update issue
    return (agency?.data as any)?.results[0].slug;
  }, [agency, router.pathname, manager]);

  const queryParamsObject = { ...router.query };
  delete queryParamsObject['view'];

  let queryParamsString = '';

  Object.keys(queryParamsObject).forEach((key) => {
    queryParamsString += `&${key}=${queryParamsObject[key]}`;
  });

  const { onCopy: onCopyListView } = useClipboard(
    `${SITE_URL}/shared/${slug}?view=list${queryParamsString}`,
  );
  const { onCopy: onCopyStackedView } = useClipboard(
    `${SITE_URL}/shared/${slug}?view=stacked${queryParamsString}`,
  );

  const handleCopyLink = useCallback(
    (value: string) => {
      if (value === 'list') onCopyListView();
      else onCopyStackedView();

      snackbar.success({
        description:
          'Link Copied: The link to this page has been copied to the clipboard',
        duration: 9000,
        isCloseable: true,
      });
    },
    [onCopyListView, onCopyStackedView, snackbar],
  );

  return (
    <>
      <Heading
        as="h3"
        size="lg"
        fontSize="lg"
        fontWeight="medium"
        lineHeight="4.5"
      >
        Links Views
      </Heading>
      <Grid
        templateColumns={{ base: '1fr', sm: '1fr 1fr' }}
        gap={2}
        paddingTop={2}
      >
        <ViewCard
          title="List View"
          description="Better for sharing longer lists of creators"
          track-id="foam-share-list-list-view"
          onClick={() => handleCopyLink('list')}
          icon={ListViewIcon}
        />
        <ViewCard
          title="Gallery View"
          description="A custom URL with a gallery view of handpicked talent"
          track-id="foam-share-list-gallery-view"
          onClick={() => handleCopyLink('stacked')}
          icon={GalleryViewIcon}
        />
      </Grid>
    </>
  );
};
